import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Flyout } from '@els/els-react--flyout';
import { ButtonWithIcon } from '@els/els-react--button';
import HoverTooltip from '@Components/HoverTooltip';
import StructureToolbarOptionsContent from '@Components/Results/structure/StructureToolbarOptionsContent';

import './StructureToolbarOptions.scss';

export default function StructureToolbarOptions({ onOpen = () => null, tooltipId, ...props }) {
  const tooltipLabel = 'Show Options';
  const flyoutRef = useRef(null);

  const handleToggle = (isOpen) => {
    if (isOpen) {
      const tooltip = document.getElementById(tooltipId);
      if (tooltip) {
        tooltip.dispatchEvent(
          new MouseEvent('mouseleave', {
            bubbles: true,
          })
        );
      }
      onOpen();
    }
  };

  const handleCloseFlyout = () => {
    // Use the Flyout's own toggleVisibility method to close it
    if (flyoutRef.current) {
      flyoutRef.current.toggleVisibility(false);
    }
  };

  return (
    <Flyout
      ref={flyoutRef}
      className="structure-toolbar-options"
      flyout={
        <div>
          <div className="u-els-margin-bottom u-els-display-flex u-els-font-size-h4 toolbar-options-label">Options</div>
          <StructureToolbarOptionsContent {...props} onClosed={handleCloseFlyout} />
        </div>
      }
      shouldCloseOnESC
      showCloseButton
      onToggle={handleToggle}
      placement="bottom-start"
      pointerType="primary">
      <HoverTooltip id={tooltipId} tooltip={tooltipLabel} tooltipPlace="top" theme="simple">
        <span id="option-button-description" className="sr-only">
          Provides actions related to the selected chemical compound.
        </span>
        <ButtonWithIcon
          sprite="Ellipsis"
          type="borderless"
          iconOnly
          data-e2e="structure-toolbar-options-button"
          aria-describedby="option-button-description">
          {tooltipLabel}
        </ButtonWithIcon>
      </HoverTooltip>
    </Flyout>
  );
}

StructureToolbarOptions.propTypes = {
  synthesisOptions: PropTypes.array,
  optionsIcon: PropTypes.string,
  context: PropTypes.object,
  metadata: PropTypes.object,
  onToggleMenu: PropTypes.func,
  onOpen: PropTypes.func,
  onItemClick: PropTypes.func,
  onOpenInDatabaseOptionClick: PropTypes.func,
  onAutoSynthesizeOptionClick: PropTypes.func,
  tooltipId: PropTypes.string,
  tooltipPlace: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};
